import React from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import home from '../../assets/intro_img.svg'
const Intro = () => {
  return (
    <Container style={{paddingTop:"7rem"}}>
      <Row>
        <Col lg={6} md={6} sm={12}
           style={{ 
        display: 'flex',        
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'first baseline',   
     
    }}>
            <h2 style={{fontSize:"4rem",fontWeight:"800"}}>
                <span style={{color:"var(--secondary)"}}>Online </span>
                <span  style={{color:"var(--primary)"}}>Education</span>
            </h2>
            <h5 style={{fontSize:"1.7rem",fontWeight:"800",color:"var(--primary)"}}>Submit Assignments, <br />
            Get Feedback, Succeed Together</h5>
<p className='text' style={{fontSize:"25px",margin:"1.4rem 0 1rem 0"}}>Amazing Teachers will check your assignments</p>
<button className='button-37' style={{backgroundColor:"#001754",border:"2px solid var(--secondary)"}}>Get Started</button>
        </Col>
      
        <Col lg={6} md={6} sm={12} style={{ padding: '0' }}>
            <img
                src={home}
                alt="Sample image"
                style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'cover',
                    borderRadius: '8px', 
                }}
            />
        </Col>
      </Row>
    </Container>
  )
}

export default Intro
